import { Download, Loader2, Search, Shield, Trash2 } from "lucide-react";

export const CampaignToolbar = ({
  allSelected,
  bulkCampaignType,
  bulkDeleting,
  campaignsCount,
  domainScanLoading,
  linksCount,
  onBulkDelete,
  onDownload,
  onScan,
  onSelectAll,
  onToggleCampaignType,
  searchTerm,
  selectedCount,
  setSearchTerm,
  updatingCampaignType,
  visibleCount,
  visibleVariantCount,
}) => (
  <div className="sticky top-3 z-20 flex flex-col gap-3 rounded-lg border border-slate-800 bg-slate-950/95 p-3 shadow-xl shadow-cyan-950/10 backdrop-blur-md" data-testid="campaign-toolbar">
    <div className="flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between">
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-3">
        <label className="flex cursor-pointer items-center gap-2 text-sm text-slate-300" data-testid="select-all-label">
          <input
            type="checkbox"
            checked={allSelected}
            onChange={onSelectAll}
            className="h-4 w-4 rounded border-slate-600 bg-slate-900 text-cyan-500 focus:ring-cyan-500"
            data-testid="select-all-checkbox"
          />
          <span data-testid="selected-links-count">{selectedCount ? `${selectedCount} selected` : "Select all"}</span>
        </label>

        <div className="relative min-w-[220px] flex-1 xl:max-w-md">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
          <input
            type="search"
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            placeholder="Search campaign, domain, path..."
            className="h-9 w-full rounded-md border border-slate-700 bg-slate-900 pl-9 pr-3 text-sm text-white outline-none transition-colors placeholder:text-slate-600 focus:border-cyan-500/70"
            data-testid="links-search-input"
          />
        </div>

        <span className="text-xs text-slate-500" data-testid="links-filter-count">
          {visibleCount} of {campaignsCount} campaigns · {visibleVariantCount} variants
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={onScan}
          disabled={domainScanLoading}
          className="flex h-9 items-center gap-2 rounded-md border border-amber-500/30 bg-amber-500/10 px-3 text-xs font-medium text-amber-300 transition-colors hover:bg-amber-500/20 disabled:opacity-50"
          data-testid="scan-links-health-btn"
          title="Scan all link domains"
        >
          {domainScanLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Shield className="h-4 w-4" />}
          Scan all
        </button>

        <div className="flex h-9 items-center gap-2 rounded-md border border-slate-700 bg-slate-900 px-3" data-testid="bulk-mode-control">
          <span className={bulkCampaignType === "direct" ? "text-xs font-semibold text-cyan-300" : "text-xs text-slate-600"}>DIRECT</span>
          <button
            type="button"
            onClick={onToggleCampaignType}
            disabled={updatingCampaignType || linksCount === 0}
            className={`relative h-5 w-10 rounded-full transition-colors ${bulkCampaignType === "b2b" ? "bg-blue-500" : "bg-cyan-500"} disabled:opacity-50`}
            data-testid="bulk-campaign-toggle"
            title={`Switch all links to ${bulkCampaignType === "direct" ? "B2B" : "Direct"}`}
          >
            <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white shadow transition-transform ${bulkCampaignType === "b2b" ? "translate-x-5" : "translate-x-0.5"}`} />
          </button>
          <span className={bulkCampaignType === "b2b" ? "text-xs font-semibold text-blue-300" : "text-xs text-slate-600"}>B2B</span>
          <span className="sr-only" data-testid="bulk-mode-status">{bulkCampaignType}</span>
        </div>

        <button
          type="button"
          onClick={onDownload}
          disabled={linksCount === 0}
          className="flex h-9 items-center gap-2 rounded-md border border-slate-700 bg-slate-900 px-3 text-xs font-medium text-slate-300 transition-colors hover:border-slate-600 hover:text-white disabled:opacity-50"
          data-testid="download-links-btn"
          title="Download all sender links"
        >
          <Download className="h-4 w-4" />
          Download
        </button>

        {selectedCount > 0 && (
          <button
            type="button"
            onClick={onBulkDelete}
            disabled={bulkDeleting}
            className="flex h-9 items-center gap-2 rounded-md border border-red-500/30 bg-red-500/10 px-3 text-xs font-medium text-red-300 transition-colors hover:bg-red-500/20 disabled:opacity-50"
            data-testid="bulk-delete-btn"
          >
            <Trash2 className="h-4 w-4" />
            {bulkDeleting ? "Deleting..." : `Delete ${selectedCount}`}
          </button>
        )}
      </div>
    </div>
  </div>
);